import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ASSETS_PATH } from 'src/app/core/config';
import { UpdateUserPasswordModel, UserBasicInfo } from 'src/app/core/models/user.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-update-my-password',
  templateUrl: './update-my-password.component.html',
  styleUrls: ['./update-my-password.component.scss']
})
export class UpdateMyPasswordComponent implements OnInit {
  userBasicInfo = new UserBasicInfo();
  updateModel = new UpdateUserPasswordModel();
  updateMyUserForm: FormGroup;
  assetsPath = ASSETS_PATH;
  isImage = false;

  constructor(private authService: AuthService,
    private alertService: AlertService,
    private userService: UserService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private router: Router) { }

  ngOnInit(): void {
    this.updateMyUserForm = this.formBuilder.group({
      oldPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20)
      ]),
      newPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20)
      ]),
      confirmNewPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20)
      ])
    });
    this.userService.getUserBasicInfo().subscribe(response => {
      if (response.success) {
        this.userBasicInfo = response;
        if (this.userBasicInfo.image !== null && this.userBasicInfo.image !== ""){
          this.isImage = true;
        }
        // this.updateMyUserForm.controls['fullName'].setValue(this.userBasicInfo.displayName);
        this.updateMyUserForm.controls['phone'].setValue(this.userBasicInfo.phone);
        this.updateMyUserForm.controls['primaryCityId'].setValue(this.userBasicInfo.primaryCityId);
        this.updateMyUserForm.controls['secondaryCityId'].setValue(this.userBasicInfo.secondaryCityId);
        this.loadingService.setLoading(false);
        }
      },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      });
  }

  get f() {
    return this.updateMyUserForm.controls;
  }

  update(){
    if (this.updateMyUserForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen bilgilerinizi doğru bir şekilde giriniz!', 'error');
      return;
    }
    if(this.updateMyUserForm.valid) {
      let dataObj = Object.assign({}, this.updateMyUserForm.value);
      this.updateModel.oldPassword = dataObj.oldPassword;
      this.updateModel.newPassword = dataObj.newPassword;
      this.updateModel.confirmNewPassword = dataObj.confirmNewPassword;
      this.loadingService.setLoading(true);
      this.userService.changePassword(this.updateModel).subscribe(response => {
        if (response.success) {
          this.alertService.alert('Başarılı', 'Şifreniz başarılı bir şekilde değiştirilmiştir!', 'success');
          this.router.navigate(['/my-profile']);
        } else {
          this.alertService.alert('Hata!', response.errors[0], 'error');
        }
        this.loadingService.setLoading(false);
      }, (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      })
    }
  }

}
